
const SaveButton = ({ onSave }) => {
    return (
        <button type="button" className="btn btn-theme" onClick={onSave}>
            Save
        </button>
    );
};

export default SaveButton;